module.exports = __webpack_public_path__ + "media/bootstrap-icons/intersect-9d5effb3.svg";